import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M15.522 7s.561-4.863-3.161-4.656-3.99 1.448-3.87 4.117c.117 3.102-.417 5.645 1.651 5.556 1.143-.049 1.923-2.207-.263-2.296-2.187-.059-4.373-.266-4.639.975-.236 1.093-.59 10.164.591 10.46 1.27.295 12.232.501 12.645-.296.562-1.123.503-9.839-.088-10.666-.532-.768-3.044-.502-3.044-.502"
    />
    <path
      strokeMiterlimit={10}
      d="M14.4 14.97c0 .9-.355 1.694-1.32 1.902-.193.034.88 1.728-.841 1.728-1.359 0-.765-1.694-.919-1.694-1.004-.173-1.32-.968-1.32-1.936 0-1.071.965-1.97 2.2-1.97s2.2.899 2.2 1.97Z"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const SecurityIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
